import React from "react";

const Regularizacao_Portugal = ({ id = '', img = '', alt = '', title = '', text = '' }) => {
    return (
        <div>
            <div id={id} className="fantasmaAncora"></div>
            <div className="bg-circle">
                <img className="number-size" src={img} alt={alt} />
            </div>
            <h3 className="text-width">{title}</h3>
            <p>
                <span dangerouslySetInnerHTML={{ __html: text }}>
                </span>
            </p>
        </div>
    );
};

const Regularizacao_Portugal_link = ({ id = '', img = '', alt = '', title = '', text = '', number = '', link = '', nameLink = '', text2 = '', text3 = '' }) => {

    const formatPhoneValues = (phoneNumber) => {
        phoneNumber = phoneNumber.replace(/[^\d]/g, '');
        return `${phoneNumber.slice(0, 3)} 
  ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 9)}`
    }

    return (
        <div>
            <div id={id} className="fantasmaAncora"></div>
            <div className="bg-circle">
                <img className="number-size" src={img} alt={alt} />
            </div>
            <h3 className="text-width">{title}</h3>
            <p>
                <span dangerouslySetInnerHTML={{ __html: text }}>
                </span>
                <a className="link" href={`tel:+351${number}`}>{formatPhoneValues(number)}</a>{text2}
                <a className='link' href={link} target='_blank' rel='noreferrer'>{nameLink}</a>
                {text3}
            </p>
        </div>
    );
};

export { Regularizacao_Portugal, Regularizacao_Portugal_link };